import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { API } from './api/api';
import { APIService } from './api/api.service';
import { UserService } from './user.service';

@Injectable()
export class RouteGuardService implements CanActivate, CanActivateChild, CanDeactivate<any> {
  isBackClicked = false;

  constructor(
    private api: API,
    private apiService: APIService,
    private userService: UserService
  ) {}

  canDeactivate(component: any) {
    if (this.getBackClicked()) {
      this.setBackClicked(false);
      if (true) {
        // window.confirm('Are you sure? Your changes may be lost.')
        return true;
      }
      history.pushState(null, null, location.href);
      return false;
    }
    return true;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.userService.getSharedStatus(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.userService.getSharedStatus(route, state);
  }

  public getBackClicked(): boolean {
    return this.isBackClicked;
  }

  public setBackClicked(b: boolean) {
    this.isBackClicked = b;
  }
}
